import React, { useState, useEffect } from "react";
import { Select } from "antd";
import { DownOutlined } from "@ant-design/icons";
import './DropdownSingleSelection.css';

const DropdownSingleSelection = (props) => {
  const dataList = props.item?.text_data;
  const fallbackText = props.item?.text;
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const isDisabled = !dataList;

  useEffect(() => {
    // If no dropdown data, default to fallbackText
    if (!dataList && fallbackText) {
      setSelectedValue(fallbackText);
      props?.inputValue?.current?.removeAttribute("disabled");
      localStorage.setItem("inputValue", JSON.stringify({ key1: fallbackText }));
    }
  }, [dataList, fallbackText, props?.inputValue]);

  const handleChange = (value) => {
    setSelectedValue(value);
    if (value) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    localStorage.setItem("inputValue", JSON.stringify({ key1: value }));
  };

  const handleOpenChange = (open) => {
    if (!isDisabled) {
      setOpen(open);
    }
  };

  const Options = dataList?.data?.map((item) => (
    <Select.Option 
      key={item.value} 
      value={item.value} 
      className={item.disabled ? "custom-option disabled-option" : "custom-option"}
    >
      {item.name}
    </Select.Option>
  ));

  return (
    <div className="dropdown-container">
      <Select
        placeholder="Please select"
        value={selectedValue}
        onChange={handleChange}
        open={open}
        onDropdownVisibleChange={handleOpenChange}
        style={{ width: "100%", color: 'white' }}
        dropdownClassName="custom-select"
        className="custom-select"
        suffixIcon={<DownOutlined style={{ color: "white" }} />}
        disabled={isDisabled}
      >
        {Options}
      </Select>
      <span className="validate">&nbsp;</span>
    </div>
  );
};

export default DropdownSingleSelection;
